import React from 'react';
import useApplication from '../../resources/applications/read';
import ErrorUnhandled from '../ErrorUnhandled';
import RevolverViewOffer from '../RevolverViewOffer';
import RevolverCardHolderAgreement from '../RevolverCardHolderAgreement';

const RevolverController = () => {
  const { data: application } = useApplication();
  const [offerStep, agreementStep] = application.attributes.approved_steps;

  if (agreementStep.enabled) {
    return <RevolverCardHolderAgreement />;
  }

  if (offerStep.enabled) {
    return <RevolverViewOffer />;
  }

  return <ErrorUnhandled />;
};

export default RevolverController;
